export const libraryList = [
  {
    id: "library1",
    musicImg:
      "https://dongsooo.github.io/imgs/img/06_playList_Chill boys - No sleep.jpg",
    musicTitle: "No sleep",
    musicSInger: "Chill boys",
  },
  {
    id: "library2",
    musicImg:
      "https://dongsooo.github.io/imgs/img/06_playList_CYGN - Mindfulness.jpg",
    musicTitle: "Mindfulness",
    musicSInger: "CYGN",
  },
  {
    id: "library3",
    musicImg:
      "https://dongsooo.github.io/imgs/img/06_playList_Daydremer - Swoon.jpg",
    musicTitle: "Swoon",
    musicSInger: "Daydremer",
  },
  {
    id: "library4",
    musicImg:
      "https://dongsooo.github.io/imgs/img/06_playList_Hoang - Desire.jpg",
    musicTitle: "Desire",
    musicSInger: "Hoang",
  },
  {
    id: "library5",
    musicImg:
      "https://dongsooo.github.io/imgs/img/06_playList_Janee - rocket science.jpg",
    musicTitle: "rocket science",
    musicSInger: "Janee",
  },
  {
    id: "library6",
    musicImg:
      "https://dongsooo.github.io/imgs/img/06_playList_Milky Day - Am I Different.JPG",
    musicTitle: "Am I Different",
    musicSInger: "Milky Day",
  },
  {
    id: "library7",
    musicImg:
      "https://dongsooo.github.io/imgs/img/06_playList_Mitis- We colide.jpg",
    musicTitle: "We colide",
    musicSInger: "Mitis",
  },
  {
    id: "library8",
    musicImg:
      "https://dongsooo.github.io/imgs/img/06_playList_san holo - ready.jpg",
    musicTitle: "ready",
    musicSInger: "san holo",
  },
];
